export class ChartInputModel {
  constructor(
    public labels: string[],
    public data: number[],
    public ideal?: number
  ) {}
}
